<template>
  <div class="ak-tree-item-toggle">
    <ak-icon
      v-if="show && !modelValue"
      type="arrow-right-b"
      @click.stop="toggle(true)"
    />
    <ak-icon
      v-if="show && modelValue"
      type="arrow-down-b"
      @click.stop="toggle(false)"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Icon from '../icon/Icon.vue'
export default defineComponent({
  name: 'ToggleChildren',
  components: {
    [Icon.name]: Icon,
  },
  props: {
    /**
     * @type {Boolean}
     * @description the modeled value
     */
    modelValue: {
      type: Boolean,
      default: false,
    },
    /**
     * @type {Boolean}
     * @description Wether or not to show toggle buttons
     */
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    /**
     * @param {Boolean} value
     * @description Update the model value
     */
    const toggle = (value) => {
      emit('update:modelValue', value)
    }
    return {
      toggle,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-tree-item-toggle {
  width: 15px;
  height: 15px;
  display: flex;
  align-content: center;
  justify-content: center;
}
</style>
